/**
 * Should match backend enum `offer_constants.BenefitsType`.
 */
export enum BenefitsType {
  US_IN_PERSON = 'US_IN_PERSON',
  US_REMOTE = 'US_REMOTE',
  GERMANY = 'GERMANY',
  JAPAN = 'JAPAN',
  KOREA = 'KOREA',
  SWEDEN = 'SWEDEN',
}

export function parseBenefitsType(benefitsTypeString: string): BenefitsType | null {
  if (Object.values(BenefitsType).includes(benefitsTypeString as BenefitsType)) {
    return benefitsTypeString as BenefitsType;
  }
  return null;
}
